import { styled } from 'styled-components';

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  flex: 1;
  overflow-y: scroll;
  padding: 18px;
  box-sizing: border-box;
`;

export default StyledContent;
